// noinspection JSUnresolvedReference

/*!
 moment.js
 version : 2.30.1
 authors : Tim Wood, Iskren Chernev, Moment.js contributors
 license : MIT https://github.com/moment/moment/blob/develop/LICENSE
 momentjs.com
 */


/*! moment.js locale configuration
     locale : German [de]
    author : lluchs : https://github.com/lluchs
    author: Menelion Elensúle: https://github.com/Oire
     author : Mikolaj Dadela : https://github.com/mik01aj
 */


import { forEach } from 'lodash';
import * as moment from 'moment';
import 'moment/locale/de';

moment.locale('de');
const openFixTicket = document.getElementById('openFixTicket');
const fixTicket_overlay = document.getElementById('fixTicket_overlay');

// Overlay öffnen bei Klick auf Button FixTicket
openFixTicket.addEventListener('click', function(event) {

    event.preventDefault();
    event.stopPropagation();

    if(typeof window.fixTicketInit === 'undefined') {
        getProgramData().then(creatDopDowns);
    }

    //todo show spinner

    fixTicket_overlay.style.display = 'block';
    fixTicket_overlay.classList.add('show');
});

async function getProgramData()
{
    let result = null;

    try{
        if(window.AllMovies !== undefined){
            return window.AllMovies;
        }

        result = await $.ajax({
            url: '/api/movies',
            method: 'get',
            success: function (result) {
                $('#ticketingOverlay').html(result);
            },
            async: true
        });
        window.AllMovies = result;
        return result;
    }catch (e) {
        console.error(e);
    }
}

// Überprüfen, ob das Klick-Event außerhalb des Overlay-Inhalts erfolgte, dann Overlay schließen
document.addEventListener('click', function(event) {
    if (fixTicket_overlay.classList.contains('show')) {
        if (!fixTicket_overlay.contains(event.target)) {
            fixTicket_overlay.classList.remove('show');
        }
    }
});

// Bei Klick auf das "X" oben rechts im Overlay, Overlay schließen
document.getElementById('closeFixTicket').addEventListener('click', function() {
    fixTicket_overlay.classList.remove('show');
});

// Dropdown Select Felder
function creatDopDowns(response) {

    function compareStrings(a, b) {
        a = a.toLowerCase();
        b = b.toLowerCase();
        return (a < b) ? -1 : (a > b) ? 1 : 0;
    }

    const filmDropdown = document.getElementById('filmDropdown');
    const tagDropdown = document.getElementById('tagDropdown');
    const zeitfensterDropdown = document.getElementById('zeitfensterDropdown');
    const timesDropDown = document.getElementById('zeitDropdown');
    const movieDropdown = document.getElementById('movieDropdown');

    // Daten für die Dropdowns


    const filme = [];
    const tage = [];
    const type = [{data: 1, html: '- Film wählen'}, {data: 2, html: 'Zeitpunkt wählen'}];

    if(response.data === null || response === null){
        //todo errorHandling

        return;
    }

    try{
        for (const [key, value] of Object.entries(response.data.filme)) {

            if(!Array.isArray(value.vorstellungen)){
                value.vorstellungen = [value.vorstellungen];
            }

            value.vorstellungen.forEach(function(e){
                var title = value.filmfakten.titel;

                if(e.vorstellungen_fakten.DreiD === '1'){
                    title += ' 3D';
                }

                if(e.vorstellungen_fakten.OrigVersion === '1'){
                    title += ' OV';
                }

                if(e.vorstellungen_fakten.OmitU === '1'){
                    title += ' OmU';
                }

                if(value.filmfakten.filmreihe_name !== '*NULL*'){
                    title += ' - '+value.filmfakten.filmreihe_name;
                }

                let id = value.filmfakten.idf === e.vorstellungen_fakten.idf ? e.vorstellungen_fakten.idf : value.filmfakten.idf+'-'+e.vorstellungen_fakten.idf

                filme.push({data: id, html: title});
            });
        }

        filme.sort(function(a, b) {
            return compareStrings(a.html, b.html);
        });

        window.test = filme;

        let now = moment();
        now.set({hour:0,minute:0,second:0,millisecond:0});
        let right = moment();

        for (const [key, value] of Object.entries(response.data.allMovies)) {
            let date = moment(key);
            date.set({hour:10});

            if(date.isAfter(now)) {
                for (const [k, v] of Object.entries(value.times)) {
                    let split = k.split(':');
                    date.set({hour: split[0], minute:split[1]});
                    if(date.isAfter(right)) {
                        tage.push({data: key, html: date.format('dddd - DD.MM.')});
                        break;
                    }
                }
            }
        }

        tage.sort(function(e,b){  return e.data > b.data ? 1 : -1;});

    }catch (e){
        console.error(e);
    }

    $('body').on('click', '.chooseType',  function(e){
        $('#whatIsUrDesire').addClass('inactive');
        if(window.fixTicketChoosen === true){
            return;
        }

        window.fixTicketChoosen = true;

        if(e.target.id === 'chooseMovie'){
            filmDropdown.style.display = 'block';

            setTimeout(function() {
                $('#filmDropdown .custom-select-trigger')[0].click();
            }, 30);
            return;
        }

        addOptionsToDropdown(tagDropdown, tage);
        tagDropdown.style.display = 'block';
        setTimeout(function() {
            $('#tagDropdown .custom-select-trigger')[0].click();
        }, 30);

    });

    function dopDownContentChange(selectedDropdown, selectedOption){
        $('#fixTicketSubmitBtn').addClass('inactive');

        if(selectedDropdown.id  === 'filmDropdown'){

            tagDropdown.style.display = 'block';
           $('#tagDropdown .custom-select-trigger').html($('#tagDropdown .custom-select-trigger').attr('data-text'));
           $('#zeitDropdown .custom-select-trigger').html($('#zeitDropdown .custom-select-trigger').attr('data-text'));
            timesDropDown.style.display = 'none';

            let tage = [];
            let now = moment();
            now.set({hour:0,minute:0,second:0,millisecond:0});

            for (const [key, value] of Object.entries(response.data.allMovies)) {

                if(value.ids.includes(selectedOption.data)){

                    let date = moment(key);

                        let right = moment();

                        for (const [k, v] of Object.entries(value.times)) {
                            let split = k.split(':');
                            date.set({hour: split[0], minute:split[1]});
                            if(date.isAfter(right)) {
                                tage.push({
                                    data: key,
                                    html: date.format('dddd - DD.MM.'),
                                    selectedMovie: selectedOption.data,
                                    moment : date
                                });
                                break;
                            }
                        }
                }

            }

            tage.sort(function(e,b){  return e.data > b.data ? 1 : -1;});

            addOptionsToDropdown(tagDropdown, tage, true);

            setTimeout(function() {
                $('#tagDropdown .custom-select-trigger')[0].click();
            }, 30);
        }

        if(selectedDropdown.id === 'tagDropdown' && selectedOption.hasOwnProperty('selectedMovie')){
            let times = [];
            zeitfensterDropdown.style.display = 'none';
            timesDropDown.style.display = 'block';
            $('#zeitDropdown .custom-select-trigger').html($('#zeitDropdown .custom-select-trigger').attr('data-text'));

            let now = moment();
            let date = moment(selectedOption.data);

            for (const [key, value] of Object.entries(response.data.allMovies[selectedOption.data].times)) {
                if(value.hasOwnProperty(selectedOption.selectedMovie)){
                    let split = key.split(':');
                    date.set({hour: split[0], minute:split[1]});
                    if(date.isAfter(now)) {
                        times.push({data: key, html: key, selectedMovie: selectedOption.selectedMovie, selectedDay: selectedOption.data, dateOrder: split[0]});
                    }
                }
            }

            times.sort((a,b) => { return parseInt(a.dateOrder) - parseInt(b.dateOrder); });

            addOptionsToDropdown(timesDropDown, times, true);
            setTimeout(function() {
                $('#zeitDropdown .custom-select-trigger')[0].click();
            }, 30);
            return;
        }

        if(selectedDropdown.id === 'tagDropdown'){

            $('#zeitDropdown .custom-select-trigger').html($('#zeitDropdown .custom-select-trigger').attr('data-text'));
            $('#zeitfensterDropdown .custom-select-trigger').html($('#zeitfensterDropdown .custom-select-trigger').attr('data-text'));
            $('#movieDropdown .custom-select-trigger').html($('#movieDropdown .custom-select-trigger').attr('data-text'));
            movieDropdown.style.display = 'none';
            timesDropDown.style.display = 'none';

            let zeitfenster = [
                {data: 1, html:'vor 14.00 Uhr',start: 8, end: 13, selectedDay: selectedOption.data},
                {data: 2, html:'14.00 - 17.00', start: 14, end: 17, selectedDay: selectedOption.data},
                {data: 3, html:'17.00 - 19.00', start: 17, end: 19, selectedDay: selectedOption.data},
                {data: 4, html:'19.00 - 22.00', start: 19, end: 22, selectedDay: selectedOption.data},
                {data: 5, html:'nach 22.00 uhr', start: 22, end: 24, selectedDay: selectedOption.data},
            ];

            let res = [];

            let date = moment(selectedOption.data);
            let now = moment();

            zeitfenster.forEach(e => {

                let start = moment(selectedOption.data);
                let end = moment(selectedOption.data);
                start.set({hour: e.start, minute: 0}).subtract(1, 'seconds');
                end.set({hour: e.end, minute: 0}).add(1, 'seconds');

                for (const [key, value] of Object.entries(response.data.allMovies[selectedOption.data].times)) {
                    let a = key.split(':');
                    date.set({hour: a[0], minute:a[1]});
                    if(date.isAfter(now) && date.isBetween(start, end)){
                        res.push(e);
                        break;
                    }
                }
            });

            zeitfensterDropdown.style.display = 'block';
            addOptionsToDropdown(zeitfensterDropdown, res, true);
            setTimeout(function() {
                $('#zeitfensterDropdown .custom-select-trigger')[0].click();
            }, 30);
        }

        if(selectedDropdown.id === 'zeitDropdown' && selectedOption.hasOwnProperty('selectedMovie')  && selectedOption.hasOwnProperty('selectedDay')){

            $('#fixTicketSubmitBtn').removeClass('inactive');

            console.log(selectedOption);

            // if(response.data.ticketing === 'blank') {
            //     window.fixTicketCallback = function() {
            //         fixTicket_overlay.classList.remove('show');
            //         window.open(response.data.allMovies[selectedOption.selectedDay].times[selectedOption.data][selectedOption.selectedMovie].link_desktop, '_blank')

            //     }
            //     return;
            // }

            // let resLink = '';

            // if (response.data.ticketing === 'kinoheldEframe') {
            //     resLink = '/ticket/small?l=*kinoheld*' + encodeURIComponent(escape(response.data.allMovies[selectedOption.selectedDay].times[selectedOption.data][selectedOption.selectedMovie].kinoheldEframeSettings));
            // } else {
            //     resLink = unescape(response.data.allMovies[selectedOption.selectedDay].times[selectedOption.data][selectedOption.selectedMovie].link_desktop).replace(/\+/g, '');
            //     resLink = '/ticket/small?l=' + encodeURIComponent(resLink);
            // }

            window.fixTicketCallback = function() {
                fixTicket_overlay.classList.remove('show');
                // $.ajax({
                //     url: resLink,
                //     success: function (result) {
                //         $('#ticketingOverlay').html(result).css('display', 'block').prepend('<p id="closeTicketingOverlay" style="position: absolute;font-size: 36px;">X</p>');
                //         $('#closeTicketingOverlay').on('click', function () {
                //             $('#ticketingOverlay').html('').css('display', 'none')
                //         });

                //     },
                //     async: true
                // });


                var dataDocumentReferrer = '';

                try{
                    let urlParsedReferrer = URL.parse(document.referrer);

                    if(urlParsedReferrer !== null) {

                        if(urlParsedReferrer.origin === document.location.origin){
                            dataDocumentReferrer = urlParsedReferrer.pathname;
                        }else{
                            dataDocumentReferrer = urlParsedReferrer.hostname.indexOf('www.') === 0 ? urlParsedReferrer.hostname.substring(4) : urlParsedReferrer.hostname;
                        }
                    }
                } catch (e) {}


                const ref = window.refer === null ? dataDocumentReferrer : window.refer + '@' + dataDocumentReferrer;

                try {
                    $.post('/control/set', {
                        refer: ref,
                        type: 'fixTicket',
                        host: window.location.hostname,
                        resourceId: selectedOption.selectedMovie,
                        href: window.location.href
                    });

                }catch (e){}


                const presentation = response.data.allMovies[selectedOption.selectedDay].times[selectedOption.data][selectedOption.selectedMovie];

                if(presentation.hasOwnProperty('resab') && typeof presentation.resab === 'string' && presentation.resab.includes('*')){

                    const dateArray = presentation.resab.split('*');
                    const time = dateArray[1].split(':');
                    const date = new Date(dateArray[0]);
                    date.setHours(parseInt(time[0]));
                    date.setMinutes(parseInt(time[1]));
                    const now = new Date();
                    if(date > now){
                        const seconds = (date.getTime() - now.getTime()) / 1000;

                        const str = seconds > 90 ? Math.ceil(milliseconds/60) + ' Minuten' : seconds + ' Sekunden';

                        window.alert('Die Vorstellung kann in '+ str +' gebucht werden.');
                        return;
                    }
                }


                if (response.data.ticketing === 'kinoheldEframe') {
                    window.open(presentation.link_fixticket, '_blank');
                  } else {
                    window.open(presentation.link_desktop, '_blank');
                  }
            }
        }

        if(selectedDropdown.id === 'zeitfensterDropdown'){
            let filme = [];

            let start = moment(selectedOption.selectedDay);
            let end = moment(selectedOption.selectedDay);
            start.set({hour: selectedOption.start, minute: 0}).subtract(1, 'seconds');
            end.set({hour: selectedOption.end, minute: 0}).add(1, 'seconds');

            let unique = [];

            for (const [key, value] of Object.entries(response.data.allMovies[selectedOption.selectedDay].times)) {
                let a = key.split(':');

                let date = moment(selectedOption.selectedDay);
                date.set({hour: a[0], minute:a[1]});

                if(date.isBetween(start, end)){

                    for (const [k, v] of Object.entries(value)) {

                        let index = '';
                        var titel = '';

                        if(k.indexOf('-') >= 0){
                            let c = k.split('-');
                            index = 'film_'+c[0];

                            if(unique.includes(index)){
                                continue;
                            }

                            unique.push(index);

                            titel = response.data.filme[index].filmfakten.titel;
                            response.data.filme[index].vorstellungen.forEach(function(e){

                              if(e.vorstellungen_fakten.idf == c[1]){
                                  if(e.vorstellungen_fakten.DreiD ==='1'){
                                      titel += " 3D";
                                  }
                                  if(e.vorstellungen_fakten.OrigVersion === '1'){
                                      title += ' OV';
                                  }

                                  if(e.vorstellungen_fakten.OmitU === '1'){
                                      title += ' OmU';
                                  }
                              }

                                if(response.data.filme[index].filmfakten.filmreihe_name !== '*NULL*'){
                                    title += ' - '+response.data.filme[index].filmfakten.filmreihe_name;
                                }
                            });
                        }else{
                            index = 'film_'+k;
                            if(unique.includes(index)){
                                continue;
                            }

                            unique.push(index);
                            titel = response.data.filme[index].filmfakten.titel;

                            if(response.data.filme[index].vorstellungen[0].vorstellungen_fakten.DreiD ==='1'){
                                titel += " 3D";
                            }
                            if(response.data.filme[index].vorstellungen[0].vorstellungen_fakten.OrigVersion === '1'){
                                title += ' OV';
                            }

                            if(response.data.filme[index].vorstellungen[0].vorstellungen_fakten.OmitU === '1'){
                                title += ' OmU';
                            }

                            if(response.data.filme[index].filmfakten.filmreihe_name !== '*NULL*'){
                                titel += ' - '+response.data.filme[index].filmfakten.filmreihe_name;
                            }
                        }

                        filme.push({data: k, html: titel, selectedDay: selectedOption.selectedDay, start: selectedOption.start, end: selectedOption.end});
                    }

                }
            }

            $('#movieDropdown .custom-select-trigger').html($('#movieDropdown .custom-select-trigger').attr('data-text'));
            $('#zeitDropdown .custom-select-trigger').html( $('#zeitDropdown .custom-select-trigger').attr('data-text'));
            timesDropDown.style.display = 'none';

            movieDropdown.style.display = 'block';
            filme.sort(function(a, b) {
                return compareStrings(a.html, b.html);
            });


            addOptionsToDropdown(movieDropdown, filme);
            setTimeout(function() {
                $('#movieDropdown .custom-select-trigger')[0].click();
            }, 30);
        }

        if(selectedDropdown.id === 'movieDropdown'){
            let times = [];
            timesDropDown.style.display = 'block';

            let start = moment(selectedOption.selectedDay);
            let end = moment(selectedOption.selectedDay);
            let date = moment(selectedOption.selectedDay);
            start.set({hour: selectedOption.start, minute: 0}).subtract(1, 'seconds');
            end.set({hour: selectedOption.end, minute: 0}).add(1, 'seconds');

            for (const [key, value] of Object.entries(response.data.allMovies[selectedOption.selectedDay].times)) {
                let a = key.split(':');
                date.set({hour: a[0], minute:a[1]});
                if(date.isBetween(start, end) ){
                    for (const [k, v] of Object.entries(value)) {
                        if(k == selectedOption.data){
                            times.push({data: key, html: key, selectedMovie: selectedOption.data, selectedDay: selectedOption.selectedDay, dateOrder:a[0]});
                        }
                    }

                }
            }

            times.sort((a,b) => { return parseInt(a.dateOrder) - parseInt(b.dateOrder); });

            addOptionsToDropdown(timesDropDown, times, true);
            setTimeout(function() {
                $('#zeitDropdown .custom-select-trigger')[0].click();
            }, 30);
        }
    }


    // Funktion zum Hinzufügen von Optionen zu den Dropdowns
    function addOptionsToDropdown(dropdown, options, clear = true) {
        if(clear){
            Array.from(dropdown.querySelectorAll('.custom-options .custom-option')).forEach(el => el.remove());
        }

        options.forEach(obj => {
            const option = document.createElement('div');
            option.classList.add('custom-option');
            option.textContent = obj.html;
            option.setAttribute('data-value', obj.data);
            option.addEventListener('click', function() {
                dropdown.querySelector('.custom-select-trigger').textContent = obj.html;
                dopDownContentChange(dropdown, obj);
                dropdown.querySelector('.custom-select-trigger').classList.remove('is-open');
                dropdown.classList.remove('opened');
            });
            dropdown.querySelector('.custom-options').appendChild(option);
        });
    }

    // Füllen der Dropdowns mit Daten
    addOptionsToDropdown(filmDropdown, filme);

    // Event-Listener für Dropdown-Trigger
    document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
        dropdown.querySelector('.custom-select-trigger').addEventListener('click', function() {
            // Schließe alle anderen Dropdowns, wenn ein neues geöffnet wird
            // this.classList.add('is-open');
            document.querySelectorAll('.custom-dropdown').forEach(otherDropdown => {
                if (otherDropdown !== dropdown) {
                    otherDropdown.classList.remove('opened', 'is-open');
                }
            });

            if(dropdown.classList.contains('inactive')){
                return;
            }

            dropdown.classList.toggle('opened');
            
            if (dropdown.classList.contains('opened')) {
                this.classList.add('is-open');
            } else {
                this.classList.remove('is-open');
            }

        });
    });

    // Schließen der Dropdowns, wenn außerhalb geklickt wird
    document.addEventListener('click', function(e) {
        document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
            if (!dropdown.contains(e.target)) {
                dropdown.classList.remove('opened', 'is-open');
            }
        });
    });

    document.getElementById('resetFixTicket').addEventListener('click', function(){
        Array.from(document.querySelectorAll('.custom-dropdown')).forEach(el => {
            el.classList.remove("inactive");
            $(el.querySelector('.custom-select-trigger')).html(el.querySelector('.custom-select-trigger').getAttribute('data-text'));
            el.querySelectorAll('.custom-select-trigger').forEach(function (element) {
                element.classList.remove('is-open');
            });
        });

        $('#whatIsUrDesire').removeClass('inactive')

        let filmDropdown = document.getElementById('filmDropdown');
        let tagDropdown = document.getElementById('tagDropdown');
        let zeitfensterDropdown = document.getElementById('zeitfensterDropdown');
        let timesDropDown = document.getElementById('zeitDropdown');
        let movieDropdown = document.getElementById('movieDropdown');

        filmDropdown.style.display = 'none';
        tagDropdown.style.display = 'none';
        zeitfensterDropdown.style.display = 'none';
        timesDropDown.style.display = 'none';
        movieDropdown.style.display = 'none';
        $('#fixTicketSubmitBtn').addClass('inactive')
        window.fixTicketChoosen = false;
    });

    const submitBtn = document.getElementById('fixTicketSubmitBtn');

    submitBtn.addEventListener('click', function() {
        if($('#fixTicketSubmitBtn').hasClass('inactive')){
            return;
        }

        window.fixTicketCallback();
    });


    window.fixTicketInit = true;
}